/**
 * «Доверие» — отдельный экран, доступный обеим ролям.
 *
 * Не вкладка: сюда не заходят каждый день. Но когда возникает вопрос
 * «а кто это поменял» или «видели ли они мою запись» — ответ должен быть
 * в одном месте, а не в переписке.
 */

import { useNavigate } from 'react-router-dom'

import { useFamily, useRole, useTimeZone } from '@/app/session'
import { TrustPanel } from '@/features/trust/TrustPanel'
import { setBackButton } from '@/shared/telegram'
import { Button } from '@/shared/ui/Button'
import { Screen } from '@/shared/ui/Screen'
import { useEffect } from 'react'

export function Trust() {
  const family = useFamily()
  const role = useRole()
  const timeZone = useTimeZone()
  const navigate = useNavigate()

  // Кнопка «назад» — системная Telegram, а не своя: так привычнее.
  useEffect(
    () => setBackButton(true, () => navigate(role === 'nanny' ? '/profile' : '/family')),
    [navigate, role],
  )

  if (!family) return null

  return (
    <Screen title="Доверие" subtitle={family.title}>
      <TrustPanel
        familyId={family.id}
        timeZone={timeZone}
        canReport={role === 'nanny'}
        canAcknowledge={role === 'parent'}
      />

      <Button
        block
        variant="ghost"
        hapticKind="none"
        onClick={() => navigate(role === 'nanny' ? '/profile' : '/family')}
      >
        Назад
      </Button>
    </Screen>
  )
}
